const VIDEO_LIST_REQUEST = 'VIDEO_LIST_REQUEST';
const VIDEO_LIST_SUCCESS = 'VIDEO_LIST_SUCCESS';
const VIDEO_LIST_FAIL = 'VIDEO_LIST_FAIL';

const VIDEO_DETAILS_REQUEST = 'VIDEO_DETAILS_REQUEST';
const VIDEO_DETAILS_SUCCESS = 'VIDEO_DETAILS_SUCCESS';
const VIDEO_DETAILS_FAIL = 'VIDEO_DETAILS_FAIL';
const REMOVE_VIDEO_DETAILS = 'REMOVE_VIDEO_DETAILS';

const VIDEO_LIST_APPLY_FILTER = 'VIDEO_LIST_APPLY_FILTER';
const VIDEO_LIST_REMOVE_FILTER = 'VIDEO_LIST_REMOVE_FILTER';

export {
  VIDEO_LIST_REQUEST,
  VIDEO_LIST_SUCCESS,
  VIDEO_LIST_FAIL,
  VIDEO_LIST_APPLY_FILTER,
  VIDEO_LIST_REMOVE_FILTER,
  VIDEO_DETAILS_REQUEST,
  VIDEO_DETAILS_SUCCESS,
  VIDEO_DETAILS_FAIL,
  REMOVE_VIDEO_DETAILS,
};
